import * as config from "./configs/production.js";
export default config;
